export default {
  messages: [
    "You find yourself in front of THREE CAVES. You hear a low and ghastly growl from one of the caves. Frightened, you look around for a something to defend yourself. This sturdy STICK will have to do for now.",
    "Welcome to the Cave Game!"
  ]
};
